module.exports = __webpack_public_path__ + "img/Figma.0bb709b0.png";